module.exports = __webpack_public_path__ + "static/media/ic-dashboard.56fbde93.svg";